<ngx-mat-timepicker
	[id]="id"
	[disabled]="disabled"
	[stepMinute]="stepMinute"
	[(ngModel)]="time"
	(ngModelChange)="onTimeChange($event)"
	>
</ngx-mat-timepicker>